/**
 * Ably Utilities
 *
 * Helper functions for Ably channel naming and operations.
 */

/**
 * Get lobby channel name for a room code
 *
 * @param roomCode - The room code
 * @returns Ably channel name
 */
export function getLobbyChannelName(roomCode: string): string {
  return `game:lobby:${roomCode}`;
}

/**
 * Get match channel name for a match ID
 *
 * @param matchId - The match/game ID
 * @returns Ably channel name
 */
export function getMatchChannelName(matchId: string): string {
  return `game:match:${matchId}`;
}

/**
 * Get user notification channel name
 *
 * @param userId - The user ID
 * @returns Ably channel name
 */
export function getUserNotificationChannelName(userId: string): string {
  return `user:${userId}:notifications`;
}

/**
 * Global announcements channel
 */
export const GLOBAL_ANNOUNCEMENTS_CHANNEL = 'global:announcements';
